import { CanActivateFn, Router} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const userRol = authService.getUser().rol;

  if (!userRol) {
    return true;
  } else {
    if(userRol === 'admin'){router.navigate(["admin/home/dashboard"]);}
    if(userRol === 'cliente'){router.navigate(["client/home/dashboard"]);}
    if(userRol === 'monitorista'){router.navigate(["monitorist/home"]);}
    return false;
  }
};
